export default {
  isLoading: false,
  notificactionHeaderList: [],
  totalUnread: 0,
  tokenJwt: null,
  openPopOver: false,
};

